import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import type {
    AccentColourType,
    ColourType,
    ExtraCategoryType,
    ExtraType,
    UpholsteryType,
} from "../../../../../../common-deprecated/types/CommonTypes";
import { removeExtra } from "../../../redux/actions/BasketActions";
import { find } from "../../../../../../common-deprecated/utils";
import { trackCustomizeConfigItem, trackSummaryRemoveExtra } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import type { FinancePackConfigurablesType } from "../../../../../shared-logic/types/FinanceTypes";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type SummaryExtraType = {
    colour: ColourType;
    primaryAccentColour: AccentColourType | null;
    secondaryAccentColour: AccentColourType | null;
    upholstery: UpholsteryType;
    categories: ExtraCategoryType[];
    basketExtras: ExtraType[];
    extras: ExtraType[];
    removeExtra: (extra: ExtraType) => void;
};

const useSummaryExtra = (): SummaryExtraType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const basketExtras = useBnbSelector((state) => state.basket.extras);
    const colour = useBnbSelector((state) => state.basket.colour);
    const primaryAccentColour = useBnbSelector((state) => state.basket.primaryAccentColour);
    const secondaryAccentColour = useBnbSelector((state) => state.basket.secondaryAccentColour);
    const upholstery = useBnbSelector((state) => state.basket.upholstery);
    const extras = useBnbSelector((state) => state.items.extras);
    const settings = useBnbSelector((state) => state.commonSettings);
    const financePacksExtras = useBnbSelector((state) =>
        state.items.financePacks.reduce((packEquipment, pack) => {
            return [...packEquipment, ...pack.equipment];
        }, [] as FinancePackConfigurablesType[]),
    );

    const filteredBasketExtras = basketExtras.filter((extra) => !find(extra.id, financePacksExtras));

    const categories = filteredBasketExtras.reduce((accumulator: ExtraCategoryType[], extra) => {
        const catName = extra.category.root ? extra.category.root.name : "";
        const category = accumulator.find(({ name }) => name === catName);
        // Filter out accessory upholsteries
        if (!CarDataConsolidator.hideExtra(extra, settings)) {
            if (!category) {
                accumulator.push({
                    id: extra.category.id,
                    code: extra.category.code,
                    name: catName,
                    sortIndex: extra.category.sortIndex,
                    extras: [extra],
                });
            } else {
                category.extras.push(extra);
            }
        }
        return accumulator;
    }, []);

    return {
        colour,
        primaryAccentColour,
        secondaryAccentColour,
        upholstery,
        categories,
        basketExtras: filteredBasketExtras,
        extras,
        removeExtra: (extra: ExtraType) => {
            trackSummaryRemoveExtra();
            trackCustomizeConfigItem(NavStep.Summary, "remove-extra");
            dispatch(removeExtra(extra, false, true));
        },
    };
};

export default useSummaryExtra;
